var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9.15018C18.94 5.52018 15.56 3.43018 12 3.43018C10.1977 3.4434 8.43491 3.95943 6.91 4.92018C5.2237 6.00041 3.80195 7.44609 2.75 9.15018C2.2584 10.0178 2 10.998 2 11.9952C2 12.9924 2.2584 13.9726 2.75 14.8402C5.06 18.4802 8.44 20.5602 12 20.5602C13.8023 20.5469 15.5651 20.0309 17.09 19.0702C18.7763 17.9899 20.1981 16.5443 21.25 14.8402C21.7416 13.9726 22 12.9924 22 11.9952C22 10.998 21.7416 10.0178 21.25 9.15018ZM12 16.0402C11.201 16.0402 10.4199 15.8032 9.7555 15.3593C9.09112 14.9154 8.57331 14.2844 8.26753 13.5462C7.96175 12.808 7.88175 11.9957 8.03763 11.212C8.19351 10.4283 8.57829 9.70847 9.14329 9.14346C9.7083 8.57846 10.4282 8.19369 11.2118 8.0378C11.9955 7.88192 12.8078 7.96192 13.546 8.2677C14.2843 8.57348 14.9152 9.0913 15.3591 9.75567C15.8031 10.42 16.04 11.2011 16.04 12.0002C16.0407 12.5309 15.9366 13.0565 15.7338 13.547C15.531 14.0374 15.2335 14.4831 14.8582 14.8584C14.4829 15.2336 14.0373 15.5312 13.5468 15.734C13.0564 15.9368 12.5307 16.0408 12 16.0402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.14014C11.4357 9.14113 10.8844 9.30928 10.4156 9.62338C9.9469 9.93747 9.58174 10.3834 9.36627 10.9049C9.1508 11.4264 9.09469 12 9.20501 12.5533C9.31533 13.1067 9.58714 13.6149 9.98611 14.0139C10.3851 14.4129 10.8933 14.6847 11.4467 14.795C12 14.9054 12.5737 14.8492 13.0952 14.6338C13.6166 14.4183 14.0626 14.0531 14.3767 13.5844C14.6908 13.1157 14.8589 12.5644 14.8599 12.0001C14.8603 11.6244 14.7866 11.2524 14.643 10.9052C14.4994 10.558 14.2888 10.2426 14.0231 9.97693C13.7575 9.71128 13.442 9.50063 13.0948 9.35704C12.7477 9.21345 12.3756 9.13974 11.9999 9.14014Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/EyeOn.883fa23ab3201ddb27e166db41612f10.svg";
export { ForwardRef as ReactComponent };